import { useState, useEffect } from 'react'
import apiClientFetch from '@/lib/api-client'

export function useBrandLogo() {
  const [brandLogo, setBrandLogo] = useState<string | null>(null)

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const data = await apiClientFetch<{key: string, value: string | null}>('/api/settings/brand_logo')
        if (data && data.value) {
          const apiUrl = process.env.NEXT_PUBLIC_API_URL || ''
          setBrandLogo(`${apiUrl}/api/files/${data.value}`)
        } else {
          setBrandLogo(null)
        }
      } catch (err) {
        console.error("Failed to load logo", err)
      }
    }
    fetchLogo()

    const handleLogoUpdate = (e: CustomEvent<string | null>) => {
      setBrandLogo(e.detail)
    }
    window.addEventListener('brandLogoUpdated', handleLogoUpdate as EventListener)
    return () => window.removeEventListener('brandLogoUpdated', handleLogoUpdate as EventListener)
  }, [])

  return brandLogo
}
